module.exports = __webpack_public_path__ + "static/img/app-bike-loop.fb45c0f7.png";